// API
import { tmxApiCall } from './index'

export default {
  async getCustomerApplication (applicationId = undefined, ccfStoreNumber = undefined, mobileMoneyLocation = undefined, mobileMoneyType = undefined, storeNumber = undefined, skipCcfiFlow = false, leadId = undefined) {
    return tmxApiCall('post', '/customerApplication', {
      applicationId,
      ccfStoreNumber,
      mobileMoneyLocation,
      mobileMoneyType,
      storeNumber,
      skipCcfiFlow,
      leadId
    })
  },

  async create (storeNumber, firstName, middleName, lastName, suffixName, cellPhoneNumber, email, state, zip, loanType, leadId, trafficChannel, invitationCode, language, year, make, model, series, style, dateOfBirth, tin, noTin, alienRegistrationNumber, hasTitle, hasTitleWithLender, referralCode, address, city, weight, height, sex, idSelection, idState, idNumber, idExpiration, scanIdBarcodeData, ccfiStoreNumber, mobileMoneyLocation, mobileMoneyType, skipCcfiFlow) {
    return tmxApiCall('post', '/applicationFromToken', {
      storeNumber: (storeNumber || '').toString(),
      firstName,
      middleName,
      lastName,
      suffixName,
      cellPhoneNumber,
      email,
      state,
      zip,
      loanType,
      leadId,
      trafficChannel,
      invitationCode,
      language,
      year,
      make,
      model,
      series,
      style,
      dateOfBirth,
      tin,
      noTin,
      alienRegistrationNumber,
      hasTitle,
      hasTitleWithLender,
      referralCode,
      address,
      city,
      weight,
      height,
      sex,
      idSelection,
      idState,
      idNumber,
      idExpiration,
      scanIdBarcodeData,
      ccfiStoreNumber,
      mobileMoneyLocation,
      mobileMoneyType,
      skipCcfiFlow
    })
  },

  async update (firstName, middleName, lastName, suffixName, applicationId, cellPhoneNumber, email, dateOfBirth, address, zip, city, state, weight, height, sex, idSelection, idState, idNumber, idExpiration, scanIdBarcodeData) {
    return tmxApiCall('put', '/applicationFromToken', {
      firstName,
      middleName,
      lastName,
      suffixName,
      applicationId,
      cellPhoneNumber,
      email,
      dateOfBirth,
      address,
      zip,
      city,
      state,
      weight,
      height,
      sex,
      idSelection,
      idState,
      idNumber,
      idExpiration,
      scanIdBarcodeData
    })
  },

  async updateAddress (applicationId, addressSameAsMailingAddress, address, optionalAddress, city, zip, state, mailingAddress, mailingOptionalAddress, mailingCity, mailingZip, mailingState) {
    return tmxApiCall('put', '/applicationFromToken', {
      address,
      optionalAddress,
      city,
      zip,
      state,
      mailingAddress,
      mailingOptionalAddress,
      mailingCity,
      mailingZip,
      mailingState,
      addressSameAsMailingAddress,
      applicationId
    })
  },

  async updateIdentification (idSelection, idNumber, idState, idExpiration, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      idSelection,
      idNumber,
      idState,
      idExpiration,
      applicationId
    })
  },

  async updateDateOfBirth (dateOfBirth, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      dateOfBirth,
      applicationId
    })
  },

  async updateTin (tin, noTin, alienRegistrationNumber, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      tin,
      noTin,
      alienRegistrationNumber,
      applicationId
    })
  },

  async updateDemographics (race, weight, height, sex, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      race,
      weight,
      height,
      sex,
      applicationId
    })
  },

  async updateRequestedAmount (requestedAmount, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      requestedAmount,
      applicationId
    })
  },

  async updateTitle (hasTitle, hasTitleWithLender, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      hasTitle,
      hasTitleWithLender,
      applicationId
    })
  },

  async updateLoginData (email, cellPhoneNumber, applicationId, referralCode, hasTitle, mobileMoneyLocation, mobileMoneyType) {
    return tmxApiCall('put', '/applicationFromToken', {
      email,
      cellPhoneNumber,
      applicationId,
      referralCode,
      hasTitle,
      mobileMoneyLocation,
      mobileMoneyType
    })
  },

  async updateBankingInfo (bankName, routingNumber, accountNumber, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      bankName,
      routingNumber,
      accountNumber,
      applicationId
    })
  },

  async updateReturnCustIndicator (returnCustIndicator, applicationId) {
    return tmxApiCall('put', '/applicationFromToken', {
      returnCustIndicator,
      applicationId
    })
  }
}
